import React, { Fragment, useEffect, useState } from "react";

import { useParams, Link } from "react-router-dom";

import axios from "axios";

import { Loader } from "../../components/global";

import HusnItem from "../../components/husns/HusnItem";

import { IconLeft } from "../../components/svg";

import { Colors } from "../../constants";

import "./Husns.scss";


const Husns = () => {
  const [husns, setHadiths] = useState(null);

  const { id } = useParams();




  // get the husns
  useEffect(() => {
    axios
      .get(`https://www.hisnmuslim.com/api/ar/${id}.json`)
      .then((response) => {
        setHadiths(Object.values(response.data)[0])
      });
  }, [id]);

  return (
    <section className="hadiths-page page">
      {husns !== null ? (
        <Fragment>
          {/* start title  */}
          <div className="title d-flex align-items-center justify-content-between">
            <h5 className="title-text">{husns.ID}</h5>
            <h6 className="av-hadith m-0">
              <span>{husns.REPEAT}</span>
            </h6>
            <Link
              to="/husn"
              className="back-btn d-flex align-items-center justify-content-center"
            >
              <IconLeft
                style={{
                  width: "2rem",
                  height: "auto",
                  fill: Colors.mainColor,
                }}
              />
            </Link>
          </div>

          <ul className="list-unstyled m-0 p-0">
            {husns.length > 0 &&
              husns.map((hadith, index) => (
                <HusnItem key={index} hadith={hadith} index={index} />
              ))}
          </ul>
        </Fragment>
      ) : (
        <Loader />
      )}
    </section>
  );
};


export default Husns;
